/* eslint-disable no-console */

import { register } from "register-service-worker";
import router from "./router";
import { store } from "./store/store";

if (process.env.NODE_ENV === "production") {
  register(`${process.env.BASE_URL}service-worker.js`, {
    ready() {
      console.log(
        "App is being served from cache by a service worker.\n" +
          "For more details, visit https://goo.gl/AFskqB"
      );
    },
    registered() {
      console.log("Service worker has been registered.");
      if(window.BroadcastChannel) {
        const channel = new BroadcastChannel('sw-messages');
        channel.addEventListener('message', async event => {

          console.log(event.data);
          if('setVar' === event.data.type) {
            window.redirectRoute = 'redirect';
            store.commit("portalemail/resetEmails", {boxType: 'all', folderId: 0});
            store.commit("portalemail/setBoxCount", {key: 'needLoad', value: true});
          } else {
            if(event.data.path.includes("emails")) {
              if(event.data.path === router.currentRoute.path) {
                window.location.reload();
              } else {
                window.redirectRoute = event.data.path;
                router.push(event.data.path);
              }
              store.commit("portalemail/setSelectedUserId", 0);
              store.commit("portalemail/resetStateForOtherUser");
            } else {
              if(event.data.path !== router.currentRoute.path) {
                window.redirectRoute = event.data.path;
                router.push(event.data.path);
              }
            }
          }

          /*if(event.data.includes("emails")) {
            if(event.data === router.currentRoute.path) {
              window.location.reload();
            } else {
              window.redirectRoute = event.data;
              router.push(event.data);
            }
          } else {
            if(event.data !== router.currentRoute.path) {
              window.redirectRoute = event.data;
              router.push(event.data);
            }
          }*/

        });
      }
    },
    cached() {
      console.log("Content has been cached for offline use.");
    },
    updatefound() {
      console.log("New content is downloading.");
    },
    updated() {
      console.log("New content is available; please refresh.");
    },
    offline() {
      console.log(
        "No internet connection found. App is running in offline mode."
      );
    },
    error(error) {
      console.error("Error during service worker registration:", error);
    }
  });
}
